import React from "react";
import ValuationForm from "@/components/ValuationForm";
import { CheckCircle2 } from "lucide-react";

export default function AvaliacaoPage() {
  return (
    <div data-testid="page-avaliacao">
      <section className="container-cnp pt-14 lg:pt-20 pb-8">
        <div className="max-w-3xl">
          <span className="tag-chip">Avaliação gratuita</span>
          <h1 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl text-stone-900 leading-[1.05]">
            Quanto vale a sua casa?<br/><span className="italic text-[#103C4A]">Peça uma avaliação, sem compromisso.</span>
          </h1>
          <p className="mt-6 text-lg text-stone-600 leading-relaxed">
            Envio um relatório de valor de mercado baseado em transações reais na sua zona, com um plano
            de marketing incluído. É 100% confidencial e sem qualquer obrigação de avançar.
          </p>
        </div>
      </section>

      <section className="container-cnp pb-20 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5 space-y-4">
          {[
            "Análise do mercado da sua rua e vizinhança",
            "Comparativo com transações recentes",
            "Plano de marketing e cronograma",
            "Estimativa de tempo até fechar",
            "100% confidencial e sem compromisso",
          ].map((s, i) => (
            <div key={i} className="flex items-start gap-3 card-soft p-5">
              <CheckCircle2 className="h-5 w-5 text-[#103C4A] mt-0.5" />
              <div className="text-stone-700">{s}</div>
            </div>
          ))}
        </div>
        <div className="lg:col-span-7 card-soft p-8">
          <ValuationForm />
        </div>
      </section>
    </div>
  );
}
